/**
 * @license
 * Copyright 2022 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */

import '@lit-labs/ssr-client/lit-element-hydrate-support.js';

export * from './lib/fixtures/csr-fixture.js';
export * from './lib/fixtures/ssr-fixture.js';
export {cleanupFixtures} from './lib/fixtures/fixture-wrapper.js';
